import {post,get} from '../../libs/ajax.js'

//模板列表
export const getTemplateList = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/list', data, options)
}

//模板归属人列表
export const getTemplateSelectUser = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/select_user', data, options)
}
//模板归属人部门
export const getTemplateSelecGroup = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/select_group', data, options)
}

// 模板获取sheet以及维度指标字段
export const getTemplateFields = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/get_fields', data, options)
}

// 创建模板提交
export const postTemplateCreate = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return post('/daily_task/template/create', data, options)
}


// 编辑 查看日报模板
export const getTemplateEdit = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/get', data, options)
}

// 编辑 模板提交
export const postTemplateUpdate = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return post('/daily_task/template/update', data, options)
}
// 编辑 删除模板
export const postTemplateDel = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return post('/daily_task/template/delete', data, options)
}

//获取推送接收人列表
export const getTemplateUserList = (data, options) => {
          options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
    return get('/daily_task/template/get_user_list', data, options)
}
//推送日报模板

export const postTemplateUserPush= (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return post('/daily_task/template/push', data, options)
}
